import { ColumnDef } from '@tanstack/react-table';
import { CompanyQueryData } from '@area-restrita/api-client/model/companyQueryData';
export const columns: ColumnDef<CompanyQueryData>[] = [
  {
    id: 'search',
    meta: { className: 'hidden' },
  },
  { id: 'tradingName', accessorKey: 'tradingName', header: 'Nome Fantasia' },
  {
    id: 'city',
    accessorFn: (row) => row.city?.name ?? 'N/A',
    header: 'Cidade',
    filterFn: (row, id, value) => value.includes(row.getValue(id)),
  },
  {
    id: 'state',
    accessorFn: (row) => row.state?.name ?? 'N/A',
    header: 'Estado',
    filterFn: (row, id, value) => value.includes(row.getValue(id)),
  },
];
